// routes/AppRoutes.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "../components/PrivateRoute";
import ManagerRoute from "../components/ManagerRoute";
import AdminRoute from "../components/AdminRoute";
import QuizRoutes from "./QuizRoutes";
import ManagerRoutes from "./ManagerRoutes";
import CommonRoutes from "./CommonRoutes";
import Error404 from "../pages/Error404";
import { QuizProvider } from "../contexts/QuizContext";
import UserRoutes from "./UserRoutes";
import AdminRoutes from "./AdminRoutes";
import PursuitAccessRoutes from "./PursuitAccessRoutes";
import PursuitAccessRoute from "../components/PursuitAccessRoute";

const AppRoutes = () => {
  return (
    <Router>
      <QuizProvider>
        <Routes>
          <Route element={<PrivateRoute />}>
            {QuizRoutes}
            {UserRoutes}
          </Route>

          <Route element={<ManagerRoute />}>{ManagerRoutes}</Route>
          <Route element={<AdminRoute />}> {AdminRoutes}</Route>
          <Route element={<PursuitAccessRoute />}> {PursuitAccessRoutes}</Route>

          {CommonRoutes}
          <Route path="*" element={<Error404 />} />
        </Routes>
      </QuizProvider>
    </Router>
  );
};

export default AppRoutes;
